import { render, staticRenderFns } from "./library-section-tabs.vue?vue&type=template&id=9999d2d0&scoped=true"
import script from "./library-section-tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./library-section-tabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./library-section-tabs.vue?vue&type=style&index=0&id=9999d2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9999d2d0",
  null
  
)

export default component.exports